import { Button } from '@/components/ui/button';
import { NodeBody, NodeContainer, NodeErrorIcon, NodeHeader, NodePrompts } from '@/nodes/NodeUI';
import type { InfoNodeType } from '@/nodes/types';
import type { GuideNodeId } from '@rock/types';
import { outgoingHandles } from '@rock/types';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import type { FC } from 'react';

const InfoNode: FC<NodeProps<InfoNodeType>> = ({ id, selected, data }) => {
    const paths = outgoingHandles.info(id as GuideNodeId, data);
    return (
        <NodeContainer>
            <NodeErrorIcon id={id} />
            <NodeHeader id={id} type={data.type} title={data.pageTitle} />
            <NodeBody selected={selected}>
                <NodePrompts prompts={data.prompts} />
                <div className="my-2">
                    <Button size="sm">{data.buttonLabel || 'Button'}</Button>
                </div>
            </NodeBody>

            <Handle type="target" position={Position.Left} />
            <Handle type="source" id={paths.next} position={Position.Right} />
        </NodeContainer>
    );
};

export default InfoNode;
